<template>
  <main>
    <PolicyHeader/>
    <background-wrapper src="policy-footer" ext="png" size="contain">
      <b-row align-h="center" class="py-6">
        <b-col lg="3" sm="4" cols="12">
          <b-card class="d-none d-sm-block sticky-top">
            <h3 v-html="$t(`${$route.name}.list.title`)"/>
            <hr class="mx-n3 my-2">
            <b-nav class="mx-n2 my-n1" vertical v-scroll-spy-active v-scroll-spy-link>
              <b-nav-item v-for="n in 18" :key="n" :href="'#list-item-' + n">
                <span v-html="n + '. ' + $t(`${$route.name}.list.items.${n}.title`)"/>
              </b-nav-item>
            </b-nav>
          </b-card>
        </b-col>
        <b-col lg="9" sm="8" cols="12">
          <b-card>
            <h2 v-html="$t(`${$route.name}.header.title`)"/>
            <p v-html="$t(`${$route.name}.list.updated`)"/>
            <hr>
            <div class="mb-n3" v-scroll-spy="{ offset: 80, time: 400 }">
              <div class="pb-3" v-for="n in 19" :key="n" :id="'list-item-' + n">
                <h4 v-html="n + '. ' + $t(`${$route.name}.list.items.${n}.title`)"/>
                <p v-html="$t(`${$route.name}.list.items.${n}.text`)"/>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </background-wrapper>
  </main>
</template>

<script>
import { PolicyHeader } from '@/components/ui'
export default {
  name: 'TermsOfUse',
  components: {
    PolicyHeader
  }
}
</script>

<style lang="sass" scoped>
h3
  +media-breakpoint-down(md)
    font-size: 1.3rem
.sticky-top
  top: 90px

.nav-item
  .nav-link
    font-size: 14px
    color: $dark

  &.active .nav-link
    color: $primary
</style>



// WEBPACK FOOTER //
// src/components/termsOfUse/TermsOfUse.vue